var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/logger.ts
import { isDevelopment } from "@base/environment/core";
import { ClientLogger } from "./console-logger.js";
function createLoggerInstance(options = {}) {
  return new ClientLogger(options);
}
__name(createLoggerInstance, "createLoggerInstance");
function createLogger(options = {}) {
  const defaults = {
    loggerType: "auto",
    // Auto-detect format based on environment if not explicitly set
    ...options.format ? {} : {
      format: typeof window === "undefined" ? "object" : "string"
    },
    ...options
  };
  return createLoggerInstance(defaults);
}
__name(createLogger, "createLogger");
function createConsoleLogger(options = {}) {
  return new ClientLogger({
    format: "string",
    ...options
  });
}
__name(createConsoleLogger, "createConsoleLogger");
var logger = createLogger({
  serviceName: "pulse-default",
  level: isDevelopment() ? "debug" : "info"
});
function createServiceLogger(serviceName, options) {
  return createLogger({
    serviceName,
    ...options
  });
}
__name(createServiceLogger, "createServiceLogger");
function withContext(context, baseLogger = logger) {
  return baseLogger.child({ context });
}
__name(withContext, "withContext");
function withPrefix(prefix, baseLogger = logger) {
  return baseLogger.child({ prefix });
}
__name(withPrefix, "withPrefix");
export {
  createConsoleLogger,
  createLogger,
  createServiceLogger,
  logger,
  withContext,
  withPrefix
};
